import { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

export function UpdateBanner() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    // Listen for SW update messages
    const handleMessage = (event) => {
      if (event.data?.type === 'SW_UPDATED') {
        setShowUpdate(true);
      }
    };
    navigator.serviceWorker.addEventListener('message', handleMessage);

    // Check for updates on registration
    navigator.serviceWorker.ready.then((reg) => {
      setRegistration(reg);
      
      // Check for waiting worker (update available)
      if (reg.waiting) {
        setShowUpdate(true);
      }

      // Listen for new worker installing
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              setShowUpdate(true);
            }
          });
        }
      });
    });

    // Check for updates every 5 minutes
    const checkInterval = setInterval(() => {
      navigator.serviceWorker.ready.then((reg) => {
        reg.update();
      });
    }, 5 * 60 * 1000);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
      clearInterval(checkInterval);
    };
  }, []);

  const handleUpdate = () => {
    if (registration?.waiting) {
      // Tell SW to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    // Reload the page
    window.location.reload();
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto">
      <div className="bg-primary text-primary-foreground rounded-xl p-4 shadow-lg flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <RefreshCw className="w-5 h-5 animate-spin-slow" />
          <span className="text-sm font-medium">Nueva versión disponible</span>
        </div>
        <button
          onClick={handleUpdate}
          className="bg-white text-primary px-4 py-1.5 rounded-lg text-sm font-bold hover:bg-opacity-90 transition-colors"
        >
          Actualizar
        </button>
      </div>
    </div>
  );
}

export default UpdateBanner;
